import { apiClient } from "../index";

const LAB_ASSISTANT_PATH = "/api/v1/lab-assistant/chat";
const LAB_ASSISTANT_HISTORY_PATH = "/api/v1/lab-assistant/history";

export async function sendLabAssistantMessage({ scenarioId, message }) {
  const response = await apiClient.post(LAB_ASSISTANT_PATH, {
    scenario_id: scenarioId,
    message,
  });

  return {
    reply: response.reply,
    tokensUsed: response.tokens_used,
    tokensRemaining: response.tokens_remaining,
    resetsAt: response.resets_at ?? null,
    windowSeconds: response.window_seconds ?? null,
  };
}

export async function getLabAssistantHistory(scenarioId) {
  const response = await apiClient.get(
    `${LAB_ASSISTANT_HISTORY_PATH}/${scenarioId}`,
  );

  return {
    messages: response.messages ?? [],
    tokensUsed: response.tokens_used,
    tokensRemaining: response.tokens_remaining,
    resetsAt: response.resets_at ?? null,
    windowSeconds: response.window_seconds ?? null,
  };
}